import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { STRIPE_URL } from "@/lib/links";
import { track } from "@/lib/analytics";

/**
 * Sticky bottom CTA bar for mobile — appears after the hero scrolls out,
 * hides again near the footer to avoid overlap.
 */
export default function MobileCTABar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const nearBottom =
        window.innerHeight + y >= document.body.scrollHeight - 640;
      setVisible(y > window.innerHeight * 0.8 && !nearBottom);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="lg:hidden fixed bottom-0 inset-x-0 z-50 p-3 bg-[#06231D]/90 backdrop-blur-xl border-t border-white/10"
          data-testid="mobile-cta-bar"
        >
          <a
            href={STRIPE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-cta-bar-button"
            onClick={() => track("cta_click", { location: "mobile_bar", product: "diagnostic" })}
            className="flex items-center justify-center gap-2 h-14 rounded-full brand-gradient text-white font-medium text-base"
          >
            Empieza el diagnóstico
            <ArrowUpRight size={18} strokeWidth={1.5} />
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
